

export class Materials {

    private _model : any;
    constructor(private _modelDefined: any) {
        this._model = this._modelDefined ? angular.copy(this._modelDefined) : {};
    }

    get material(): string {
        return this._model.material;
    }

    set material(val: string) {
        this._model.material = val;
    }


    get description(): string {
        return this._model.description;
    }

    set description(val: string) {
        this._model.description = val;
    }

    get assetNumber(): string {
        return this._model.assetNumber;
    }

    set assetNumber(val: string) {
        this._model.assetNumber = val;
    }

    get quantity(): string {
        return this._model.quantity;
    }

    set quantity(val: string) {
        this._model.quantity = val;
    }


    get netWeight(): string {
        return this._model.netWeight;
    }

    set netWeight(val: string) {
        this._model.netWeight = val;
    }


    get costPerUnit(): number {
        return this._model.costPerUnit;
    }

    set costPerUnit(val: number) {
        this._model.costPerUnit = val;
    }

    get countryName(): string {
        return this._model.countryName;
    }

    set countryName(val: string) {
        this._model.countryName = val;
    }


    get countryCode(): string {
        return this._model.countryCode;
    }

    set countryCode(val: string) {
        this._model.countryCode = val;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetail/models/materials.ts
 **/